import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactBSAlert from "react-bootstrap-sweetalert";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

import FormControl from "@material-ui/core/FormControl";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";

import { getAllLaundries, addLaundry,updateLaundry } from "../../network/ApiAxios";
import { redirectToLogout } from "common/SharedFn";
import { Block, CalendarToday, Check, Edit, Group, Receipt } from "@material-ui/icons";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});


const LaundriesTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [success, setSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [addModal, setAddModal] = useState(false);
  // const [countries, setCountries] = useState([]);
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [locationCoordinates, setLocationCoordinates] = useState("");
  const [assignedBlocks, setAssignedBlocks] = useState("");
  const [status, setStatus] = useState(1);
  const [id, setId] = useState();
  const [executeUpdate, setExecuteUpdate] = useState(false);
  const [executeDelete, setExecuteDelete] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);

  const warningAlert = (title,message,action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const accessUsersPage = (id) => {
    let history = createHistory();
    history.push("/admin/laundries/"+id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const accessOrdersPage = (id) => {
    let history = createHistory();
    history.push("/admin/laundryOrdersView/"+id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const accessSlotsPage = (id) => {
    let history = createHistory();
    history.push("/admin/laundries/slots/"+id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const setCurrentRecord = (info) => {
    const { id, name,phoneNumber,locationCoordinates,assignedBlocks,status } = info;
    setName(name);
    setPhoneNumber(phoneNumber);
    setLocationCoordinates(locationCoordinates);
    setAssignedBlocks(assignedBlocks);
    setStatus(status);
    setId(id);
  };

  const clearCurrentRecord = () => {
    setName('');
    setPhoneNumber('');
    setLocationCoordinates('');
    setAssignedBlocks('');
    setStatus(1);
    setId();
  };

  const fetchLaundries = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try{
    const response = await getAllLaundries();
    const { data } = response;
    // const responseCountries = await getAllCountries();
    if (data.result.isSuccess) {
      // setCountries(responseCountries.data.data);
      setData(data.data.map((prop) => makeTableRow(prop)));
      //setError("");
    } else {
      showErrorNotification(data.result.description);
      if(data.result.code == -2){
        redirectToLogout();
      }
    }
    }
    catch(ex){
      showErrorNotification("Failed to fetch laundries");
    }
    setIsLoading(false);
  };



  const addLaundryEntity = async () => {
    setIsLoading(true);
    try{
    const response = await addLaundry(name,phoneNumber,locationCoordinates,assignedBlocks,status);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Laundry Added Successfully");
      setAddModal(false);
      setForceRefresh(true);
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to add laundry");
      setIsLoading(false);
    }
  };


  const updateLaundryEntity = async () => {
    setExecuteUpdate(false);
    setIsLoading(true);
    try{
    const response = await updateLaundry(id,name,phoneNumber,locationCoordinates,assignedBlocks,status);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Laundry Updated Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to update laundry");
      setIsLoading(false);
    }
  };


  useAsyncEffect(async () => {
    if(executeUpdate){
        updateLaundryEntity();
    }
    else{
      fetchLaundries();
    }
  }, [executeUpdate,forceRefresh]);

  const makeTableRow = (info) => {
    if (info.status == 1) {
      info.statusText = "Yes";
    } else {
      info.statusText = "No";
    }
    return {
      ...info,
      actions: (
        <div className="actions-right">
          <Tooltip title="View Users">
            <Button size="small" color="primary" variant="contained" onClick={() => {
                accessUsersPage(info.id);
            }}>
              <Box component={Group} />
            </Button>
          </Tooltip>
          <Tooltip title="View Slots" 
                  style={{ marginLeft: "5px" }}>
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedSuccess,
                  }}  variant="contained" onClick={() => {
                accessSlotsPage(info.id);
            }}>
              <Box component={CalendarToday} />
            </Button>
          </Tooltip>
          <Tooltip title="View Orders" style={{ marginLeft: "5px" }}>
            <Button size="small" color="default" variant="contained" onClick={() => {
                accessOrdersPage(info.id);
            }}>
              <Box component={Receipt} />
            </Button>
          </Tooltip>
          <Tooltip title="Edit">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedWarning,
                  }} 
                  variant="contained" 
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                setCurrentRecord(info);
                setAddModal(true);
            }}>
              <Box component={Edit} />
            </Button>
          </Tooltip>
          <div style={{ display: "inline-block" }}>
            {info.status == 1 ? (
              <Tooltip title="Disable">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedInfo,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {warningAlert("Disable Laundry","Are you sure you would like to disable the laundry "+info.name+"?",async () =>  {
                    setCurrentRecord(info);
                    setStatus(Math.abs(info.status-1));
                    setAlert(null);
                    setExecuteUpdate(true);
                    
                  })}}
                >
                  <Box component={Block} />
                </Button>
              </Tooltip>
            ) : (
              <Tooltip title="Enable">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedSuccess,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {warningAlert("Enable Laundry","Are you sure you would like to enable the laundry "+info.name+"?",async () => {
                    setCurrentRecord(info);
                    setStatus(Math.abs(info.status-1));
                    setAlert(null);
                    setExecuteUpdate(true);
                  })}}
                >
                  <Box component={Check} />
                </Button>
              </Tooltip>
            )}
          </div>
        </div>
      ),
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Laundries</Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "id",
                    text: "ID",
                    sort: true,
                  },
                  {
                    dataField: "name",
                    text: "Name",
                    sort: true,
                  },
                  {
                    dataField: "phoneNumber",
                    text: "Phone Number",
                    sort: true,
                  },
                  {
                    dataField: "locationCoordinates",
                    text: "Location Coordinates",
                    sort: true,
                  },
                  {
                    dataField: "assignedBlocks",
                    text: "Assigned Blocks",
                    // sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}        
                  },
                  // {
                  //   dataField: "countryByCountryId.nameEn",
                  //   text: "Country",
                  //   sort: true,
                  // },
                  {
                    dataField: "statusText",
                    text: "Is Enabled",
                    sort: true,
                  },
                  {
                    dataField: "actions",
                    text: "Actions",
                    csvExport: false
                  },
                ]}
                search
                exportCSV
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <Grid container className="pl-4">
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        style={{ marginBottom: "15px" }}
                      >
                        <Tooltip
                          title="Add new laundry"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedPrimary,
                            }}
                            onClick={() => {
                              clearCurrentRecord();
                              setAddModal(true);}}
                          >
                            <span>Add</span>
                          </Button>
                        </Tooltip>

                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                          <ExportCSVButton
                            className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedSizeSmall MuiButton-sizeSmall"
                            {...props.csvProps}
                          >
                            <span className="MuiButton-label">Download</span>
                          </ExportCSVButton>
                        {/* </Tooltip> */}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div
                          id="datatable-basic_filter"
                          className="dataTables_filter px-4 pb-1 float-right"
                        >
                          <label>
                            Search:
                            <SearchBar
                              className="form-control-sm"
                              placeholder=""
                              {...props.searchProps}
                            />
                          </label>
                        </div>
                      </Grid>
                    </Grid>

                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </Grid>
        </Grid>
        <Dialog
                classes={{
                  root: classes.center + " " + classes.modalRoot,
                  paper: classes.modal + " " + classes.modalSmall,
                }}
                open={addModal && !isLoading}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setAddModal(false)}
              >
                <DialogTitle
                  disableTypography
                  className={classes.modalHeader}
                >
                  <h4 className={classes.modalTitle}>
                    {id == null || id === "" ? "Add" : "Edit"} Laundry
                  </h4>
                </DialogTitle>
                <DialogContent
                  className={classes.modalBody + " " + classes.modalSmallBody}
                >
                  <form>
                <FormGroup>
                  <FormLabel>Name</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Name"
                    value={name ?? ""}
                    onChange={(e) => setName(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Phone Number</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Without + and 00. Example 97312345678"
                    value={phoneNumber ?? ""}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                    <FormLabel>Location Coordintaes</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="XX.XXXXXX,XX.XXXXXX"
                      value={locationCoordinates ?? ""}
                      onChange={(e) =>
                        setLocationCoordinates(e.target.value)
                      }
                    />
                  </FormGroup>
                <FormGroup>
                  <FormLabel>Assigned Blocks (Comma seperated)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Assigned Blocks (Comma seperated)"
                    value={assignedBlocks ?? ""}
                    onChange={(e) => setAssignedBlocks(e.target.value)}
                  />
                </FormGroup>
                {/* <FormGroup>
                  <FormLabel>Country</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={countryId} onChange={(e) => setCountryId(e.target.value)} IconComponent={KeyboardArrowDown}>
                    {countries.map(function(country, i){
                        return <MenuItem value={country.id}>{country.nameEn}</MenuItem>;
                    })}
                    </Select>
                  </FormControl>
                </FormGroup> */}
                <FormGroup>
                  <FormLabel>Is Enabled</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={status} onChange={(e) => setStatus(e.target.value)} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={1}>Yes</MenuItem>
                      <MenuItem value={0}>No</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
                </form>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setAddModal(false)}
                  >
                    Cancel
                  </Button>
                  
                    <Button
                      onClick={() =>
                        id == null || id === "" ? addLaundryEntity() : updateLaundryEntity()
                      }
                      
                  classes={{
                    root: classes.buttonContainedPurple100,
                  }}
                      variant="contained"
                    >
                      {id == null || id === "" ? "Add" : "Update"}
                    </Button>
                  
                </DialogActions>
              </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default LaundriesTable;
